module.exports = __webpack_public_path__ + "static/media/cross-icon.1600d71a.svg";